module.exports = __webpack_public_path__ + "img/bg6.5864a59c.png";